var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.991 6.00909L5.39886 10.5637L9.59362 12.9922L13.293 9.29283C13.6835 8.90231 14.3167 8.90231 14.7072 9.29283C15.0977 9.68336 15.0977 10.3165 14.7072 10.707L11.0078 14.4064L13.4364 18.6012L17.991 6.00909ZM18.3138 3.76552C19.5093 3.3331 20.667 4.49076 20.2345 5.68629L14.952 20.2908C14.5185 21.4895 12.882 21.6354 12.2433 20.5322L9.02565 14.9744L3.46786 11.7567C2.36469 11.1181 2.5105 9.4816 3.70921 9.04802L18.3138 3.76552Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLine);
export default __webpack_public_path__ + "static/media/send_line.a6c765c033b4ef56a69b643e0b5ad4d3.svg";
export { ForwardRef as ReactComponent };